/**
 * Convert a horizontal pointer position into a playback fraction.
 *
 * Playback begins at the inline start of the track: the left edge in LTR
 * interfaces and the right edge in RTL interfaces. Keeping this calculation
 * in logical direction matches the way the progress fill is rendered.
 */
export function playbackFractionFromPointer(clientX, bounds, rtl = false) {
  if (!Number.isFinite(bounds.width) || bounds.width <= 0) return 0;

  const physicalFraction = (clientX - bounds.left) / bounds.width;
  const logicalFraction = rtl ? 1 - physicalFraction : physicalFraction;

  return Math.max(0, Math.min(1, logicalFraction));
}
